// extracted by mini-css-extract-plugin
module.exports = {"container":"news-contents_container__cAuGM"};